import corporateAxios from './corporateAxios'

export const corporates = () => {
  return corporateAxios.get(`/corporates`, )
}

export const corporate = (bankId,corporateSenderId) => {
  return corporateAxios.get('/'+bankId+`/${corporateSenderId}`)
}

export const postCorporate = (bankId,corporate) => {
  return corporateAxios.post('/'+bankId+`/create`, corporate)
}

export const putCorporate = (bankId,corporate) => {
  return corporateAxios.put('/'+bankId+`/update`, corporate)
}

export const enableCorporate = (bankId,corporate) => {
  return corporateAxios.put('/'+bankId+`/enable`, corporate)
}

export const disableCorporate = (bankId,corporate) => {
  return corporateAxios.put('/'+bankId+`/disable`, corporate)
}

export const deleteCorporate = (bankId,corporate) => {
  return corporateAxios.put('/'+bankId+`/delete`, corporate)
}

export const getCorporatesByBankId = (corporate) => {
  return corporateAxios.post(`/bybank`, corporate)
}

